export const ROLES = {
  admin: 'ADMIN',
  operator: 'OPERATOR',
};
